import {
    DEALERPROFILE_SUCCESS,
    DEALERPROFILE_FAILED,
    RESET_DEALERPROFILE,
    LOADING_DEALERPROFILE,
    NETWORK_ERROR_DEALERPROFILE
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERPROFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERPROFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERPROFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERPROFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERPROFILE:
            return (state = initialState);
        default:
            return state;
    }
};